import React from 'react';
import styles from './ResultsBar.module.scss';
import Badge from './Badge';
import { BadgeSizes, BadgeStyles } from './Badge';
import Result from './Result';
import { useDeviceDetection } from '../utils/DeviceDetection';

export default function ResultsBar({
	show,
	results,
	searchLabel,
	collapsed,
	onResultClick,
	focusedResult,
	onResultBarScroll
}) {
	const resultsBarRef = React.useRef();
	const isMobile = useDeviceDetection();

	function focusResult() {
		const resultsBarDOMElement = resultsBarRef.current;

		if (resultsBarDOMElement) {
			const resultsScroll = resultsBarDOMElement.scrollLeft;

			for (let i = 0; i < resultsBarDOMElement.children.length; i++) {
				const resultDOMElement = resultsBarDOMElement.children[i];

				if (
					Math.round(resultsScroll - resultDOMElement.offsetLeft) ===
					0
				) {
					onResultBarScroll(resultDOMElement.id);
					break;
				}
			}
		}
	}

	function scrollToResult(id) {
		const resultsBarDOMElement = resultsBarRef.current;

		if (resultsBarDOMElement) {
			for (let i = 0; i < resultsBarDOMElement.children.length; i++) {
				const resultDOMElement = resultsBarDOMElement.children[i];
				const resultId = resultDOMElement.id;

				if ('result-' + id === resultId) {
					const resultOffsetTop = resultDOMElement.offsetTop;
					resultsBarDOMElement.scrollTo({
						top: resultOffsetTop - resultsBarDOMElement.offsetTop,
						behavior: 'smooth'
					});
					break;
				}
			}
		}
	}

	const resultsHTML =
		results &&
		results.map((result, index) => (
			<Result
				key={result.id}
				result={result}
				onResultClick={onResultClick}
				highlighted={
					focusedResult ? result.id === focusedResult.id : null
				}
			/>
		));

	return show && !collapsed ? (
		<div className={styles.root}>
			{!isMobile ? (
				<div className={styles.resultsHeader}>
					{searchLabel}
					<Badge
						text={results?.length}
						size={BadgeSizes.MEDIUM}
						variant={BadgeStyles.SECONDARY}
					/>
				</div>
			) : null}
			<ul
				ref={resultsBarRef}
				className={styles.resultsList}
				onScroll={isMobile ? focusResult : null}
			>
				{resultsHTML}
			</ul>
		</div>
	) : null;
}
